import axios from '@axios'
import config from '@core/app-config/api-config'

const identityAdmin = `${config.host}/identity/admin`

const identityApi = {
  getGreyProfiles(params) {
    return axios.get(`${identityAdmin}/grey-profiles`, { params })
  },
  createGreyFromResult(payload) {
    return axios.post(`${identityAdmin}/grey-profiles`, payload)
  },
  getUnmatchedResults(params) {
    return axios.get(`${identityAdmin}/unmatched-results`, { params })
  },
  suggestResult(payload) {
    return axios.post(`${identityAdmin}/suggestions`, payload)
  },
  getSuggestions(params) {
    return axios.get(`${identityAdmin}/suggestions`, { params })
  },
  getClaims(params) {
    return axios.get(`${identityAdmin}/claims`, { params })
  },
  resolveClaim(id, resolution) {
    return axios.post(`${identityAdmin}/claims/${id}/resolve`, { resolution })
  },
  getConflicts(params) {
    return axios.get(`${identityAdmin}/conflicts`, { params })
  },
  resolveConflict(id, resolution) {
    return axios.post(`${identityAdmin}/conflicts/${id}/resolve`, { resolution })
  },
  getMissingRequests(params) {
    return axios.get(`${identityAdmin}/missing-event-requests`, { params })
  },
  updateMissingRequest(id, status) {
    return axios.patch(`${identityAdmin}/missing-event-requests/${id}`, { status })
  },
  /** An external result of the request: 'approved' counts it in the person's statistics, 'rejected' does not */
  decideMissingResult(id, decision, comment) {
    return axios.post(`${identityAdmin}/missing-event-requests/${id}/result`, { decision, comment })
  },
  getAnomalies(params) {
    return axios.get(`${identityAdmin}/anomalies`, { params })
  },
  getAudit(params) {
    return axios.get(`${identityAdmin}/audit`, { params })
  },
  searchUsers(params) {
    const query = typeof params === 'string' ? { q: params } : params
    return axios.get(`${identityAdmin}/users/search`, { params: query })
  },
  inviteGreyActivate(id, payload = {}) {
    return axios.post(`${identityAdmin}/grey-profiles/${id}/invite-activate`, payload)
  },
  getCorrections(params) {
    return axios.get(`${identityAdmin}/corrections`, { params })
  },
  resolveCorrection(id, approve) {
    return axios.post(`${identityAdmin}/corrections/${id}/resolve`, { approve })
  },
  getMergeRequests(params) {
    return axios.get(`${identityAdmin}/merge-requests`, { params })
  },
  resolveMergeRequest(id, approve) {
    return axios.post(`${identityAdmin}/merge-requests/${id}/resolve`, { approve })
  },
  getStats() {
    return axios.get(`${identityAdmin}/stats`)
  },
  getSecurityEvents(params) {
    return axios.get(`${identityAdmin}/security-events`, { params })
  },
}

export default identityApi
